// Limpeza da base que ficou com o service worker do PWA (ENG-843).
//
// Roda para TODO visitante, não só para quem instalou o PWA: o worker antigo
// era registrado em qualquer carregamento do site, inclusive em navegador
// comum.
//
// Por que pela página e não por um service worker autodestrutivo, que é a
// receita mais comum: um SW não consegue distinguir a própria registration da
// de terceiros, porque `self.registration.unregister()` age sobre o ESCOPO e
// não sobre o script — e o Smartico mantém os próprios workers de push no
// mesmo origin. Aqui, `getRegistrations()` expõe o `scriptURL` de cada uma e o
// casamento é exato.
//
// De quebra isto não depende do update check do `/sw.js`, que hoje nem
// funcionaria: sem o módulo do PWA a URL cai no fallback do SPA e devolve
// `text/html`, script inválido para service worker. O worker antigo ficaria
// registrado indefinidamente.
const OWN_SERVICE_WORKER_PATH = '/sw.js';

// Só os caches que o nosso worker criou. Enumerar e apagar tudo que
// `caches.keys()` devolve destruiria cache de terceiros no mesmo origin.
const OWN_CACHE_NAMES = ['website-static-cached', 'cf-static-images'];

async function unregisterOwnServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return;
  }

  const registrations = await navigator.serviceWorker.getRegistrations();

  await Promise.all(
    registrations.map(async (registration) => {
      const worker =
        registration.active ?? registration.waiting ?? registration.installing;

      if (!worker) {
        return;
      }

      const { pathname } = new URL(worker.scriptURL, location.origin);

      if (pathname === OWN_SERVICE_WORKER_PATH) {
        await registration.unregister();
      }
    }),
  );
}

async function deleteOwnCaches() {
  if (!('caches' in window)) {
    return;
  }

  await Promise.all(OWN_CACHE_NAMES.map((name) => caches.delete(name)));
}

export default defineNuxtPlugin(() => {
  // Sem `await`: a limpeza é oportunista e não pode atrasar o carregamento.
  //
  // NÃO recarregamos a página nem os clients abertos — o worker antigo só
  // cacheava asset estático e imagem, e o JS do app já vem com hash de deploy
  // no caminho, então não há o que refrescar. Um reload forçado destruiria
  // depósito ou aposta em preenchimento de quem nunca teve PWA.
  //
  // Por isso a limpeza se completa em DOIS loads, e isso é da especificação do
  // Service Worker, não um descuido: `unregister()` remove a registration mas
  // não para o worker que já controla esta página — ele segue interceptando
  // até o client descarregar, e o StaleWhileRevalidate dele recria o
  // `website-static-cached` logo depois do `delete`. No load seguinte não há
  // mais controller, nada reintercepta, e o `delete` vale. Como isto roda em
  // toda carga, o segundo load fecha a conta sozinho.
  Promise.all([unregisterOwnServiceWorker(), deleteOwnCaches()]).catch(
    (error) => {
      console.warn('pwa-cleanup: falha ao limpar o service worker', error);
    },
  );
});
